import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatMoney } from 'accounting';

import DetailLineItems from './DetailLineItems';
import Item from '../../../../models/Item';
import InfoBox from '../../../common/InfoBox';
import ComparativeValueChart from './ComparativeValueChart';
import formPropsType from '../../../common/types/formPropsType';
import './Financials.css';

class Financials extends PureComponent {
  render() {
    const { item, formProps, startInEditMode } = this.props;

    const valueTooltip = ({ data, value }) => (
      <span>
        {data.category}<br />
        {formatMoney(value, '$', 0)}<br />
      </span>
    );

    return (
      <div className="financialsGrid">
        <InfoBox title="Stats">
          <dl>
            <DetailLineItems
              item={item}
              properties={['market_value', 'purchase_price']}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />

            <dt>Value Gain/Loss</dt>
            <dd>
              <span
                style={{
                  color: item.valueGain >= 0 ? 'green' : 'red',
                }}
              >
                {formatMoney(item.valueGain)}
              </span>
            </dd>

            <dt>Item Rank</dt>
            <dd>{item.itemRank}</dd>
          </dl>
        </InfoBox>

        <InfoBox title="Average Market Value Comparison">
          <ComparativeValueChart
            item={item} 
            tooltipTextFn={valueTooltip}
          />
        </InfoBox>
      </div>
    );
  }
}

Financials.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  formProps: formPropsType.isRequired,
  startInEditMode: PropTypes.bool,
};

Financials.defaultProps = {
  startInEditMode: false,
};

export default Financials;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/Financials.jsx